<template>
    <b-modal ref="profile_modal" size="xl" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             :hide-footer="true"
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2><span class="fw-300">ID:{{this.doc.doc_id}}</span></h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="panel-body p-4">
                <hr_add
                    @close_modal="close"
                    @close_reload_modal="close_reload"
                    :is_modal=true
                    :doc_id="doc.doc_id">
                </hr_add>
            </div>
        </div>
        
        <template v-slot:modal-footer="{close}">
        
        </template>
    </b-modal>
</template>

<script >
import hr_add from "./hr_add.vue";

export default {
    name: "hr_user_edit",
    components: {
        hr_add
    },
    created() {
        EventBus.$on('edit_user',this.edit_user);
        EventBus.$on('remove_new_user',this.remove_user);
        EventBus.$on('remove_move_user',this.remove_move);
    },
    
    props : {
        show_id: {
            type : Number | String,
            default : 0,
        }
    },
    
    data() {
        return {
            modal_position: "right",
            is_show_modal: false,
            is_load: false,
            
            doc: {
                doc_id : 0,
                doc_type : 0,
                doc_rights : "deny",
             },
        }
    },
    
    methods: {
        
        edit_user(event) {
            console.log(event);
            if(event.hasOwnProperty('doc_id')) {
                this.doc.doc_id = event.doc_id;
            }
            
            if(event.hasOwnProperty('doc_type')) {
                this.doc.doc_type = event.doc_type;
            }
            
            if(event.hasOwnProperty('doc_rights')) {
                this.doc.doc_rights = event.doc_rights;
            }
            
            this.is_show_modal = true;
        },
        
        close_modal() {
            this.close();
        },
        
        close() {
            console.log('close trigger');
            this.doc = this.default_item;
            this.is_show_modal = false;
        },
        
        close_reload() {
            window.location.reload();
        },
        
        async remove_move(event) {
            if(event.hasOwnProperty('doc_id')) {
                this.doc.doc_id = event.doc_id;
            }
            
            const is_ok = confirm_imc('Видалити ?');
            is_ok.then(res => {
                
                api.delete('/hr/move/' + this.doc.doc_id).then(({data}) => {
                    if (data.status === "operation_success") {
                        window.location.reload();
                    }
                }).catch(err => {
                    if (err.response && err.response.hasOwnProperty('data')) {
                        EventBus.$emit('show_toast', {
                            err: err.response.data.message,
                            type: "danger",
                            title: err.response.data.status
                        });
                    } else {
                        EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                    }
                })
                    .finally(() => {
                        IMC_CORE.hideloading();
                        this.close();
                    });
            });
        },
        
        async remove_user(event) {
            
            if(event.hasOwnProperty('doc_id')) {
                this.doc.doc_id = event.doc_id;
            }
            
            const is_ok = confirm_imc('Видалити ?');
            is_ok.then(res => {
                
                api.delete('/hr/docs/' + this.doc.doc_id).then(({data}) => {
                    if (data.status === "operation_success") {
                        window.location.reload();
                    }
                }).catch(err => {
                    if (err.response && err.response.hasOwnProperty('data')) {
                        EventBus.$emit('show_toast', {
                            err: err.response.data.message,
                            type: "danger",
                            title: err.response.data.status
                        });
                    } else {
                        EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                    }
                })
                .finally(() => {
                    IMC_CORE.hideloading();
                    this.close();
                });
            });
        },
    },
    
    computed: {
        default_item() {
            return {
                doc_id : 0,
                doc_type : 0,
                doc_rights : "deny",
            }
        },
        
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-xl";
            }
            
            return "modal-dialog-right modal-xl";
        },
    }
}
</script>


<style scoped>

</style>